<template>
  <div>
    <div class="invoices__filter" v-if="invoices.length > 0">
      <div class="invoices__filter-label">{{ t('invoices.yearFilter') }}</div>
      <select class="invoices__year" ref="year" @change.stop="yearSelected">
        <option v-for="year in years" :value="year" :key="year">
          {{ year }}
        </option>
      </select>
    </div>

    <template v-if="invoices.length > 0">
      <div class="invoice" v-for="invoice in invoices" :key="invoice.name">
        <div class="invoice__label">
          {{ formatDate(invoice.date, 'date') }}
        </div>
        <a :href="invoice.url" class="invoice__link" target="_blank">
          {{ invoice.name }}
          <IconExternal />
        </a>
      </div>
    </template>
    <div class="invoices__empty" v-else-if="invoicesLoaded">
      {{ t('settings.noInvoices') }}
    </div>
    <div class="invoices__loading" v-else>
      {{ t('settings.loadingInvoices') }}
    </div>
  </div>
</template>

<script setup>
  import IconExternal from '@/components/icons/External.vue'
  import { useDate } from '@/composables/useDate.ts'
  import { useStrings } from '@/composables/useStrings.ts'
  import { useInvoices } from '@/composables/useInvoices.ts'
  import { onMounted } from 'vue'

  const { formatDate } = useDate()
  const { t } = useStrings()
  const { years, invoicesOfYear: invoices, invoicesLoaded, selectYear, load } = useInvoices()

  onMounted(load)

  const yearSelected = (event) => {
    selectYear(parseInt(event.target.value, 10))
  }
</script>

<style lang="scss">
  .invoices {
    &__filter {
      margin-bottom: $spacer20;

      &-label {
        display: inline-block;
        line-height: 2rem;
        margin-right: $spacer10;
      }
    }
  }

  .invoice {
    margin-top: $spacer10;

    @media (min-width: $bp-sm) {
      display: flex;
      margin-top: $spacer05;
    }

    &__label {
      line-height: $line-height-sm;
      color: $grey-dark;
      flex-basis: 25%;

      @media (min-width: $bp-sm) {
        font-size: $font-size-lg;
        line-height: $line-height-base;
      }
    }

    &__link {
      font-size: $font-size-lg;
      color: $body-color;
      transition: $transition-base;

      .icon {
        width: 1em;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>
